require('./bootstrap');
require('jquery-confirm');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

import('./commons');
import('./header');
import('./courses');
import('./galleries');
import('./comments');
import('./checkout');
import('./blogs');
import('./mycourse');
import('./action');
import('./booking');

import('./components/countdown');
import('./components/editor');

